export default "__VITE_ASSET__4bK8HQj$__"